import Nav from './components/nav/Nav';
import LandingPage from './pages/landing/LandingPage';

function App() {
  return (
    <div className='overflow-hidden'>
      <Nav />
      <LandingPage />
    </div>

  );
}

export default App;
